var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 121,
    viewBox: "0 0 30 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3918 120.38H27.4364V112.558H29.3918V120.38ZM29.3918 100.826H27.4364V93.0049H29.3918V100.826ZM29.3918 81.2728H27.4364V73.4514H29.3918V81.2728ZM29.3918 61.7193H27.4364V53.8979H29.3918V61.7193ZM29.3918 42.1658H27.4364V34.3444H29.3918V42.1658ZM29.3918 22.6122H27.4364V14.7908H29.3918V22.6122ZM9.70139 22.1821L8.33264 20.7742L13.9445 15.3383L15.3133 16.7462L9.70139 22.1821ZM23.7408 8.57282L22.3721 7.16496L29.3722 0.379883V3.05871H28.7465L29.0594 3.39114L23.7017 8.57282H23.7408Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04176 25.9033L0 28.8335L1.35658 30.2417L4.39834 27.3115L3.04176 25.9033Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber1);
export default __webpack_public_path__ + "static/media/NUMBER_1.cbfec151b1cd11b295b5f02bd652f659.svg";
export { ForwardRef as ReactComponent };